
export class ZFactorReq {
 itemId:number;

}